import {STATE_CONSTANTS} from "../../constants/swiftConstants";
import {CommonActions} from "../actions/commonActions";
import {
    RESET_SWIFT_READABLE_ID,
    UPDATE_CREATION_METHOD,
    UPDATE_PROGRAM,
    UPDATE_PURPOSE,
    UPDATE_SWIFT_READABLE_ID
} from "../types/commonTypes";

const initialState = {
    selectPurpose: STATE_CONSTANTS.SELECT_PURPOSE_STATE,
    selectProgram: STATE_CONSTANTS.SELECT_PROGRAM_STATE,
    selectCreationMethod: STATE_CONSTANTS.SELECT_CREATION_METHOD_STATE,
    swiftReadableId: ""
}

const commonReducer = (state = initialState, action: CommonActions) => {
    switch (action.type) {
        case UPDATE_PURPOSE:
        case UPDATE_PROGRAM:
        case UPDATE_CREATION_METHOD:
            return {
                ...state,
                ...action.payload
            }
        case UPDATE_SWIFT_READABLE_ID:
            return {
                ...state,
                swiftReadableId: action.payload
            }
        case RESET_SWIFT_READABLE_ID:
            return {
                ...state,
                swiftReadableId: ""
            }
        default:
            return state;
    }
}

export default commonReducer;